import { Link } from "react-router-dom";
import { cn } from "~/lib/utils";
import { ROUTE_NEXTGEN_VIEW } from "~/router/constants";
import { Agent } from "~/services/agents";

interface AgentCardProps {
  agent: Agent;
}

export const AgentCard = ({ agent }: AgentCardProps) => {
  return (
    <Link
      to={`${ROUTE_NEXTGEN_VIEW}/agents/${agent.id}`}
      className={cn(
        "group flex flex-col gap-2 rounded-xl border border-border bg-card p-5",
        "shadow-sm transition-colors hover:border-border/80 hover:bg-accent/40",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      )}
    >
      <span className="text-base font-semibold text-card-foreground leading-tight group-hover:text-foreground">
        {agent.display_name}
      </span>
      <span className="line-clamp-2 text-sm text-muted-foreground">{agent.description}</span>
    </Link>
  );
};
